<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
        <p class="modal-title">{{data.nzTitle}}</p>
    </div>
    <div class="flex justify-end">
        <nz-input-group class="w-[200px]" [nzPrefix]="searchIconFinalProduct" [nzSuffix]="clearInputFinalProduct">
            <input onfocus="select()" placeholder="Busca un artículo" nz-input [(ngModel)]="searchFinalProduct"
                (ngModelChange)="onSearchFinalProduct($event)" />
        </nz-input-group>
        <ng-template #clearInputFinalProduct>
            @if (searchFinalProduct) {
            <span class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="clearFilterFinalProduct()"
                nz-icon></span>
            }
        </ng-template>
        <ng-template #searchIconFinalProduct>
            <span nz-icon nzType="search"></span>
        </ng-template>
    </div>
</div>

<div #modalContent class="w-full h-full p-0 m-0">
    @if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
        @if (finalProducts && finalProducts.length > 0) {
            <nz-table #basicTable [nzData]="finalProductsFiltered" class="m-0 p-0" nzSize="small" [nzLoading]="isLoading"
                nzTableLayout="fixed" [nzLoadingIndicator]="indicatorTemplate" [nzBordered]="true" [nzFrontPagination]="false" [nzShowPagination]="false"
                [nzScroll]="{ y: (tableHeight || 0) + 'px' }">
                <thead>
                    <tr>
                        <th nzWidth="50px"></th>
                        <th nzWidth="500px">Artículo</th>
                        <th nzWidth="200px">Lote</th>
                        <th nzWidth="200px">Formatos</th>
                        <th nzWidth="200px">Cantidad</th>
                    </tr>
                </thead>
                <tbody>
                    @for(finalProduct of basicTable.data; track idxFinalProduct; let idxFinalProduct = $index){
                    <tr>
                        <td [nzExpand]="expandSetFinalProduct.has(idxFinalProduct)"
                            (click)="onExpandFinalProductChange(idxFinalProduct, expandSetFinalProduct.has(idxFinalProduct))"
                            class="text-center align-middle"></td>
                        <td>{{ finalProduct.article?.name }}</td>
                        <td>{{ finalProduct.articleBatch?.batchNumber }}</td>
                        <td class="text-right align-middle">{{ getFinalProductPackagingsCount(finalProduct.id!) }}</td>
                        <td class="text-right align-middle">{{ (openedFromFinaliseProcess ? finalProduct.quantityProduced :
                            finalProduct.quantityToProduce) | number:'1.0-2' }} {{ getDisplayUnit() }}</td>
                    </tr>
                    <tr [nzExpand]="expandSetFinalProduct.has(idxFinalProduct)">
                        @if (expandSetFinalProduct.has(idxFinalProduct) ){
                            @if ( finalProduct.article?.usePackagings && getFinalProductPackagingsCount(finalProduct.id!) > 0 ) {
                                <!---------------------------------------------------------------------------->
                                <!--------------------------- EXPAND PACKAGINGS------------------------------->
                                <!---------------------------------------------------------------------------->
                                <nz-table #packingsExpandTable style="margin: -9px 0px !important"
                                    [nzData]="finalProduct.packagings ? finalProduct.packagings : []" [nzFrontPagination]="false"
                                    [nzShowPagination]="false" [nzBordered]="true" nzTableLayout="fixed" nzSize="small" [nzVirtualItemSize]="41"
                                    [nzVirtualForTrackBy]="trackByIndexPackaging" [nzScroll]="{ y: (tableHeight-100 || 0) + 'px', x:'240px' }">
                                    <thead>
                                        <tr>
                                            <th colspan="6">
                                                <div class="flex justify-between items-center">
                                                    <p>Formatos de <b>{{finalProduct.article?.name}}</b></p>
                                                    <nz-input-group class="w-[200px]" [nzPrefix]="searchIconPackaging"
                                                        [nzSuffix]="clearInputPacking">
                                                        <input onfocus="select()" placeholder="Busca un formato" nz-input
                                                            [(ngModel)]="searchPackaging[idxFinalProduct]"
                                                            (ngModelChange)="onSearchPackaging($event, idxFinalProduct)" />
                                                    </nz-input-group>
                                                    <ng-template #clearInputPacking>
                                                        @if (searchPackaging[idxFinalProduct]) {
                                                        <span class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
                                                            (click)="clearFilterPackaging(idxFinalProduct)" nz-icon></span>
                                                        }
                                                    </ng-template>
                                                    <ng-template #searchIconPackaging>
                                                        <span nz-icon nzType="search"></span>
                                                    </ng-template>
                                                </div>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th nzWidth="50px"></th>
                                            <th nzWidth="200px">Tipo formato</th>
                                            <th nzWidth="200px">Lote</th>
                                            <th nzWidth="200px">Cantidad</th>
                                            <th nzWidth="200px">Materias primas utilizadas</th>
                                            <th nzWidth="200px">Acciones</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <ng-template nz-virtual-scroll let-packaging let-idxPackaging="index">
                                            <tr>
                                                <!-------------------------------------------------------------------->
                                                <!---------------------------- EXPAND -------------------------------->
                                                <!-------------------------------------------------------------------->
                                                <td [nzExpand]="expandSetPackage.has(idxPackaging)" (click)="onExpandPackageChange(idxPackaging, expandSetPackage.has(idxPackaging))"
                                                    class="text-center align-middle"></td>
                                                <!-------------------------------------------------------------------->
                                                <!---------------------------- TIPO FORMATO -------------------------->
                                                <!-------------------------------------------------------------------->
                                                <td class="align-middle">
                                                    {{ packaging.packagingType?.name }}
                                                </td>
                                                <!------------------------------------------------------------>
                                                <!---------------------------- LOTE -------------------------->
                                                <!------------------------------------------------------------>
                                                <td class="align-middle">
                                                    {{ packaging.batchNumber }}
                                                </td>

                                                <!---------------------------------------------------------------->
                                                <!---------------------------- CANTIDAD -------------------------->
                                                <!---------------------------------------------------------------->
                                                <td class="text-right align-middle">
                                                    {{ packaging.quantity | number:'1.0-2' }} {{ getDisplayUnit() }}
                                                </td>

                                                <!-------------------------------------------------------------------------------->
                                                <!---------------------------- CANTIDAD MATERIAS PRIMAS -------------------------->
                                                <!-------------------------------------------------------------------------------->
                                                <td class="text-right align-middle">
                                                    {{ packaging.rawMaterials?.length ? packaging.rawMaterials?.length : 0 }}
                                                </td>
                                                <td>
                                                    <div class="flex align-middle justify-center">
                                                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                                            [nzTooltipTitle]="'Editar cantidad del formato'" nzTooltipPlacement="bottom" nz-tooltip
                                                            (click)="editPackagingFromFinalProduct(packaging, idxFinalProduct)">
                                                            <span nz-icon nzType="edit"></span>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <!--------------------------------------------------------------------------------->
                                            <!--------------------------- EXPAND RAW MATERIAL --------------------------------->
                                            <!--------------------------------------------------------------------------------->
                                            <tr [nzExpand]="expandSetPackage.has(idxPackaging)" style="width: 100% !important">
                                                @if (expandSetPackage.has(idxPackaging)){
                                                    <nz-table #packingsRawMaterialsExpandTable style="margin: -9px 0px !important"
                                                        [nzData]="packaging.rawMaterials ? packaging.rawMaterials :[]"[nzFrontPagination]="false"
                                                        [nzShowPagination]="false" [nzBordered]="true" nzTableLayout="fixed" nzSize="small" [nzVirtualItemSize]="41"
                                                        [nzVirtualForTrackBy]="trackByIndexPackaging" [nzScroll]="{ y: (tableHeight-100 || 0) + 'px', x:'240px' }">
                                                        <thead>
                                                            <tr>
                                                                <th colspan="5">
                                                                    <div class="flex justify-between items-center">
                                                                        <p>Materias primas utilizadas en <b>{{packaging.packagingType?.name}}</b></p>
                                                                        <nz-input-group class="w-[200px]" [nzPrefix]="searchIcon"
                                                                            [nzSuffix]="inputClearTpl">
                                                                            <input onfocus="select()" placeholder="Busca una materia prima" nz-input
                                                                                [(ngModel)]="searchRawMaterialInPackaging[idxFinalProduct+'_'+idxPackaging]"
                                                                                (ngModelChange)="onSearchRawMaterialInPackaging($event, idxFinalProduct, idxPackaging)" />
                                                                        </nz-input-group>
                                                                        <ng-template #inputClearTpl>
                                                                            @if (searchRawMaterialInPackaging[idxFinalProduct+'_'+idxPackaging]) {
                                                                            <span class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
                                                                                (click)="clearFilterRawMaterialInPackaging(idxFinalProduct, idxPackaging)" nz-icon></span>
                                                                            }
                                                                        </ng-template>
                                                                        <ng-template #searchIcon>
                                                                            <span nz-icon nzType="search"></span>
                                                                        </ng-template>
                                                                    </div>
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th nzWidth="200px">Materia prima</th>
                                                                <th nzWidth="200px">Lote</th>
                                                                <th nzWidth="200px">Formato</th>
                                                                <th nzWidth="200px">Cantidad</th>
                                                                <th nzWidth="200px">Acciones</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            @for ( rawMaterial of packingsRawMaterialsExpandTable.data; track i; let i = $index ) {
                                                            <tr>
                                                                <!---------------------------- MATERIA PRIMA -------------------------->
                                                                <!--------------------------------------------------------------------->
                                                                <td class="align-middle">
                                                                    {{ rawMaterial.article?.name }}
                                                                </td>
                                                                <!---------------------------- LOTE -------------------------->
                                                                <!------------------------------------------------------------>
                                                                <td class="align-middle">
                                                                    {{ rawMaterial.articleBatch?.batchNumber }}
                                                                </td>
                                                                <!---------------------------- FORMATO -------------------------->
                                                                <!------------------------------------------------------------>
                                                                <td class="align-middle">
                                                                    {{ rawMaterial.usedPackaging?.packagingType?.name }}
                                                                </td>
                                                                <!---------------------------- CANTIDAD -------------------------->
                                                                <!---------------------------------------------------------------->
                                                                <td class="text-right">
                                                                    {{ rawMaterial.quantity }} {{ rawMaterial.article?.measurementUnit?.abbreviation }}
                                                                </td>

                                                                <!---------------------------- ACCIONES -------------------------->
                                                                <!---------------------------------------------------------------->
                                                                <td>
                                                                    <div class="flex align-middle justify-center">
                                                                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                                                            [nzTooltipTitle]="'Editar cantidad de la materia prima'" nzTooltipPlacement="bottom"
                                                                            nz-tooltip (click)="editRawMaterialFromFinalProduct(rawMaterial)">
                                                                            <span nz-icon nzType="edit"></span>
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            }
                                                        </tbody>
                                                    </nz-table>
                                                }
                                            </tr>
                                        </ng-template>
                                    </tbody>
                                </nz-table>
                            }
                            @else {
                                <!--------------------------------------------------------------------------------->
                                <!--------------------------- EXPAND RAW MATERIAL --------------------------------->
                                <!--------------------------------------------------------------------------------->
                                <nz-table #rawMaterialsExpandTable style="margin: -9px 0px !important"
                                    [nzData]="finalProduct.rawMaterials ? finalProduct.rawMaterials : []" [nzFrontPagination]="false"
                                    [nzShowPagination]="false" [nzBordered]="true" nzTableLayout="auto" nzSize="small">
                                    <thead>
                                        <tr>
                                            <th colspan="4">
                                                <div class="flex justify-between items-center">
                                                    <p>Materias primas utilizadas en <b>{{finalProduct.article?.name}}</b></p>
                                                    <nz-input-group class="w-[200px]" [nzPrefix]="searchIcon" [nzSuffix]="inputClearTpl">
                                                        <input onfocus="select()" placeholder="Busca una materia prima" nz-input
                                                            [(ngModel)]="searchRawMaterial[idxFinalProduct]"
                                                            (ngModelChange)="onSearchRawMaterial($event, idxFinalProduct)" />
                                                    </nz-input-group>
                                                    <ng-template #inputClearTpl>
                                                        @if (searchRawMaterial[idxFinalProduct]) {
                                                        <span class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
                                                            (click)="clearFilterRawMaterial(idxFinalProduct)" nz-icon></span>
                                                        }
                                                    </ng-template>
                                                    <ng-template #searchIcon>
                                                        <span nz-icon nzType="search"></span>
                                                    </ng-template>
                                                </div>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>Materia prima</th>
                                            <th>Lote</th>
                                            <th>Cantidad</th>
                                            <th nzWidth="200px">Acciones</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        @for ( rawMaterial of rawMaterialsExpandTable.data; track i; let i = $index ) {
                                        <tr>
                                            <!---------------------------- MATERIA PRIMA -------------------------->
                                            <!--------------------------------------------------------------------->
                                            <td class="align-middle">
                                                {{ rawMaterial.article?.name }}
                                            </td>
                                            <!---------------------------- MATERIA PRIMA -------------------------->
                                            <!--------------------------------------------------------------------->
                                            <td class="align-middle">
                                                {{ rawMaterial.articleBatch?.batchNumber ? rawMaterial.articleBatch?.batchNumber : '-' }}
                                            </td>
                                            <!---------------------------- CANTIDAD -------------------------->
                                            <!---------------------------------------------------------------->
                                            <td class="text-right align-middle">
                                                {{ rawMaterial.rawQuantity }} {{ rawMaterial.article?.measurementUnit?.abbreviation }}
                                            </td>

                                            <!---------------------------- ACCIONES -------------------------->
                                            <!---------------------------------------------------------------->
                                            <td>
                                                <div class="flex align-middle justify-center">
                                                    <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                                        [nzTooltipTitle]="'Editar cantidad de la materia prima'" nzTooltipPlacement="bottom"
                                                        nz-tooltip (click)="editRawMaterialFromFinalProduct(rawMaterial)">
                                                        <span nz-icon nzType="edit"></span>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        }
                                    </tbody>
                                </nz-table>
                            }
                        }
                    </tr>
                }
                </tbody>
            </nz-table>
        }
        @else {
            <div class="w-full h-full content-center">
                <nz-empty></nz-empty>
            </div>
        }
    }
</div>

<ng-template #indicatorTemplate>
    <app-loader></app-loader>
</ng-template>

<div *nzModalFooter>
    <div class="flex justify-end">
        <button class="button secondary-button mr-2" (click)="handleCancel()">
            Cancelar
        </button>

        @if(openedFromFinaliseProcess){
            <button nz-button class="button primary-button" (click)="updateStock()" [nzLoading]="isSaving">
                Continuar
            </button>
        }
    </div>
</div>
